export const MOBILE_TOP_BAR_HEIGHT = 56;
export const DESKTOP_TOP_BAR_HEIGHT = 64;
export const DESKTOP_EXPERIMENT_BANNER_HEIGHT = 120;
